import { Star } from "lucide-react";
import { REVIEWS } from "@/data/content";
import { SITE } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

const Card = ({ r }) => (
  <figure className="mx-3 w-[80vw] shrink-0 whitespace-normal rounded-2xl border border-charcoal/10 bg-card p-7 shadow-[0_10px_40px_rgba(26,54,38,0.08)] sm:w-[420px] md:p-9">
    <div className="flex gap-1 text-gold">
      {Array.from({ length: r.rating }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-current" />
      ))}
    </div>
    <blockquote className="mt-5 font-serif text-2xl font-light leading-snug text-forest md:text-[1.7rem]">“{r.text}”</blockquote>
    <figcaption className="mt-6 text-sm">
      <span className="font-medium text-charcoal">{r.name}</span>
      <span className="text-charcoal/50"> · {r.from}</span>
    </figcaption>
  </figure>
);

export default function ReviewsSlider({ heading = true }) {
  const row = [...REVIEWS, ...REVIEWS];
  return (
    <section data-testid="reviews-slider" className="overflow-hidden bg-ivory py-14 md:py-20">
      {heading && (
        <div className="mx-auto mb-14 max-w-[1400px] px-5 text-center md:px-10">
          <Reveal><p className="mb-5 text-xs uppercase tracking-widest-2 text-brown md:text-sm">Guest Stories</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mx-auto max-w-3xl font-display text-4xl font-bold leading-[1.05] tracking-tight text-forest sm:text-5xl md:text-6xl">
              Loved by those who wandered in
            </h2>
          </Reveal>
          <a
            href={SITE.googleReviews}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-btn"
            className="mt-7 inline-flex items-center gap-2.5 rounded-full border border-forest/25 bg-white px-6 py-3 text-sm font-medium text-forest shadow-[0_6px_20px_rgba(26,54,38,0.08)] transition-all duration-300 hover:-translate-y-0.5 hover:border-forest"
          >
            <Star className="h-4 w-4 fill-gold text-gold" /> Read Our Google Reviews
          </a>
        </div>
      )}

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 md:w-28 bg-gradient-to-r from-ivory to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 md:w-28 bg-gradient-to-l from-ivory to-transparent" />
        <div className="marquee-reviews items-stretch py-2">
          {row.map((r, i) => (
            <Card key={i} r={r} />
          ))}
        </div>
      </div>
      <p className="mt-8 text-center text-sm text-charcoal/50">Hover / hold to pause</p>
    </section>
  );
}
